import React, { Component } from 'react';
import '../../App.css';
import GoogleMapReact from 'google-map-react';

import Footer from '../reusables/footer'

const Location = () => <div><a className="fa fa-map-marker" id="contact-icon" style={{fontSize:'2em', padding:'0.6em 0 0.6em 0'}}></a></div>;

class contact extends Component {
    static defaultProps = {
        center: {
          // lat: -0.156887,
          // lng: -78.461696
          lat: -0.216864,
          lng: -78.490954
        },
        zoom: 18
      };

  render() {
    return (
      <div className="Contact">
        <div className="col-3-container">
            <div className="col">
                <a className="fa fa-map-marker" id="contact-icon"></a>
                <p>
                  {/* Gral.Duma & De Las Claveles, Monteserin, Quito  D.M. 170124 */}
                  <b>Nuestras oficinas</b><br/>
                  Av.Velasco Ibarra y Rufino Marín Sector La Vicentina
                </p>
            </div>
            <div className="col">
                <a className="fa fa-phone" id="contact-icon"></a>
                <p>
                    <b>Gerencia General</b><br/>
                    02 3341896<br/>
                    <b>Presidencia</b><br/>
                    0998439924<br/>
                    <b>Departamento de ventas</b><br/>
                    0989012765<br/>
                    <b>Asistente de ventas</b><br/>
                    0961082204
                </p>
            </div>
            <div className="col">
                <a className="fa fa-envelope" id="contact-icon"></a>
                <p>
                    <b>Presidente</b><br/>
                    presidencia@pioricost.com<br/>
                    <b>Gerente de ventas</b><br/>
                    salesmanager@pioricost.com
                </p>
            </div>
        </div>
        
        <div style={{ height: '50vh', width: '100%', margin: '3em 0 0 0' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyA0JPpEMHGXDfurPDZoJqT_KF6nw2S4Wns" }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <Location
            // lat={-0.156650}
            // lng={-78.461850}
            lat={-0.216864}
            lng={-78.490954}
            text={'Pioricost'}
          />
        </GoogleMapReact>
      </div>
      <Footer/>
      </div>
    );
  }
}

export default contact;


// WEBPACK FOOTER //
// ./src/components/contact/index.js